import React, { useMemo } from 'react';
import Navigator from '../../config/navigation';
import SessionManager from '../../routes/SessionManager';
import logo from './../../assets/img/sitekick-logo-text.svg';
import BreadCrumb from './BreadCrumb';
import Navbar from './Navbar';
import NavbarNav from './NavbarNav';

const Header = React.memo((props) => {

    const nav = useMemo(
        () => new SessionManager().readCookie('user', false) == null ? null : Navigator.getNav('app'),
        []
    );

    return (
        nav && window.location.pathname !== '/' ?
            <React.Fragment>
                <Navbar className={props.className} showMenu={nav && Object.keys(nav).length > 0} app_name='SiteKick' logo={logo} showNavbarLogin={props.showNavbarLogin} >
                    <NavbarNav nav={nav} key='0' />
                </Navbar>
                <BreadCrumb />
            </React.Fragment> :
            ""
    );
});

export default Header;